
import { Notification } from "./notification";
import { NotificationRecordableCategory } from "./notificationrecordablecategory";
import { NotificationRecordableOwner } from "./notificationrecordableowner";

export class NotificationRecordable extends Notification {
    public notificationRecordableCategories?: NotificationRecordableCategory[] = [];
    public notificationRecordableOwners?: NotificationRecordableOwner[] = [];
}